import styled from 'styled-components/macro'
import { Link } from 'react-router-dom'

export const TableLink = styled(Link)`
  color: #0097fe;
  font-family: Roboto;
  font-weight: 400;
`
